<div class="schema-page">
  <div class="schema-header">
    <h1>Country schema · Field mapping</h1>
    <p>See exactly what fields a country's chain expects — its own field names, what's required, and what stays off-chain.</p>
  </div>

  <app-error-banner [message]="errorMessage()" />

  @if (isLoading()) {
    <p class="hint">Loading...</p>
  } @else if (availableCountries.length === 0) {
    <app-empty-state message="No country has a configured schema yet." />
  } @else {
    <div class="toolbar">
      <div class="country-toggle">
        @for (code of availableCountries; track code) {
          <button
            class="toggle-btn"
            [class.toggle-btn--active]="selectedCountry() === code"
            (click)="selectCountry(code)"
          >
            {{ countryLabel(code) }}
          </button>
        }
      </div>

      <label class="field-search">
        <span class="material-icons">search</span>
        <input [(ngModel)]="fieldSearch" name="fieldSearch" (ngModelChange)="onSearchChange()" placeholder="Search by field name..." />
      </label>
    </div>

    @if (groupedRules.length === 0) {
      <app-empty-state message="No fields match your search." />
    } @else {
      @for (group of groupedRules; track group.eventType) {
        <section class="group-card">
          <h2>{{ eventTypeLabel(group.eventType) }}</h2>

          <table>
            <thead>
              <tr>
                <th>Field</th>
                <th>{{ selectedCountry() }} calls it</th>
                <th>Required</th>
                <th>Published on chain</th>
              </tr>
            </thead>
            <tbody>
              @for (rule of pagedGroupRules(group); track rule.term) {
                <tr>
                  <td><code>{{ rule.term }}</code></td>
                  <td>
                    @if (rule.localName) {
                      <code>{{ rule.localName }}</code>
                    } @else {
                      <span class="muted">{{ rule.term }} (default)</span>
                    }
                  </td>
                  <td>
                    <span class="pill" [class.pill--yes]="rule.required" [class.pill--no]="!rule.required">
                      {{ rule.required ? 'Required' : 'Optional' }}
                    </span>
                  </td>
                  <td>
                    <span class="pill" [class.pill--yes]="rule.onChain" [class.pill--no]="!rule.onChain">
                      {{ rule.onChain ? 'Published' : 'Withheld' }}
                    </span>
                  </td>
                </tr>
              }
            </tbody>
          </table>

          <div class="pagination">
            <div class="page-size-control">
              <span>Results per page</span>
              <app-page-size-select [sizes]="pageSizeOptions" [ngModel]="pageSize()" (ngModelChange)="onPageSizeChange($event)" name="pageSize" />
            </div>

            <div class="pagination-pill">
              <button class="page-nav" (click)="goToGroupPage(group, groupPage(group) - 1)" [disabled]="groupPage(group) === 0">
                <span class="material-icons">chevron_left</span>
                Previous
              </button>
              @for (p of groupPageWindow(group); track $index) {
                @if (p === -1) {
                  <span class="page-ellipsis">…</span>
                } @else {
                  <button class="page-dot" [class.page-dot--active]="p === groupPage(group)" (click)="goToGroupPage(group, p)">
                    {{ p + 1 }}
                  </button>
                }
              }
              <button class="page-nav" (click)="goToGroupPage(group, groupPage(group) + 1)" [disabled]="groupPage(group) === groupTotalPages(group) - 1">
                Next
                <span class="material-icons">chevron_right</span>
              </button>
              <span class="pagination-divider"></span>
              <span class="pagination-summary">Showing {{ groupRangeStart(group) }}–{{ groupRangeEnd(group) }} of {{ group.rules.length }} fields</span>
            </div>
          </div>
        </section>
      }
    }
  }
</div>
